import Inertia from './inertia'
import shouldIntercept from './should-intercept'

export default Inertia
export { shouldIntercept }
